<!--
    描述：项目管理 -- 待审核项目- 租赁通
    时间：2022-07-25
    Created by 李家宝
-->
<template>
  <div class="juyi-project-msg-main">
    <div class="expert-content">
      <el-form
        :model="zulinProjectMsg"
        label-width="170px"
        size="small"
        ref="personForm"
        :show-message="false"
      >
        <el-row class="mb20">
          <el-col :span="24">
            <h3>{{ zulinProjectMsg.sname }}</h3>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="当前状态：" class="item">
              <span style="font-weight: bolder">{{ currentState }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="提交时间：">
              <span v-if="rowData.isVerify != 1">{{
                zulinProjectMsg.createDate | dateFilter
              }}</span>
              <span v-else>--</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="期望产品入场时间：">
              <span class="redtext">
                {{ zulinProjectMsg.mobilizationTime }}</span
              >
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="入场地址：">
              {{ zulinProjectMsg.projectProvinceName
              }}{{ zulinProjectMsg.projectCityName }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="详细地址：">
              {{ zulinProjectMsg.detailAddress }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="付款方式：">
              {{ zulinProjectMsg.paymentMethod }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="工期长度：">
              {{ zulinProjectMsg.durationLength }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否采用电子合同：">
              <span v-if="zulinProjectMsg.electronicContractFlag == 0"
                >不选择</span
              >
              <span v-if="zulinProjectMsg.electronicContractFlag == 1"
                >不采用</span
              >
              <span v-if="zulinProjectMsg.electronicContractFlag == 2"
                >采用</span
              >
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="发票类型：">
              <span v-if="zulinProjectMsg.isInvoice == 0">不选择</span>
              <span v-if="zulinProjectMsg.isInvoice == 1">增值税普票</span>
              <span v-if="zulinProjectMsg.isInvoice == 2">增值税专票</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否需支付报价保证金：">
              <span v-if="zulinProjectMsg.bondFlag == 0">不选择</span>
              <span v-if="zulinProjectMsg.bondFlag == 1">不需要</span>
              <span v-if="zulinProjectMsg.bondFlag == 2">需要</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系方式：">
              <div style="display: flex;align-items: center">
                <span>{{ phone }}</span>
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="isShow ? '点击显示手机号' : '点击隐藏手机号'"
                  placement="top-start"
                >
                  <img
                    v-if="isShow"
                    @click="isShowPhone"
                    class="icon"
                    src="../../../assets/images/display.png"
                  />
                  <img
                    v-else
                    @click="isShowPhone"
                    class="icon"
                    src="../../../assets/images/hide.png"
                  />
                </el-tooltip>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="合同模板：">
              <div v-if="zulinProjectMsg.contractTemplateUrl != ''">
                <el-button type="text" @click="doView">
                  {{ zulinProjectMsg.contractTemplateName }}{{ fileSuffixName }}
                </el-button>
                <el-button type="text" @click="doView" style="color: #FF6600"
                  >查看</el-button
                >
                <el-button
                  type="text"
                  @click="doDownload"
                  style="color: #FF6600"
                  >下载</el-button
                >
              </div>
              <div v-else><el-button type="text">暂无附件</el-button></div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="求租截止时间：">
              <span class="redtext">{{ zulinProjectMsg.deadline }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="项目描述：">
              <p
                style="width: 64%;font-size:14px;font-family: Avenir, Helvetica, Arial, sans-serif;white-space:pre-wrap;word-break:break-all;"
              >
                {{ zulinProjectMsg.projectDes }}
              </p>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="产品类别：">
              {{ zulinProjectMsg.jobDetailsObj.productCategoryName }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="品牌：">
              {{ zulinProjectMsg.jobDetailsObj.brand }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="规格：">
              {{ zulinProjectMsg.jobDetailsObj.categorySpecification }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="型号：">
              {{ zulinProjectMsg.jobDetailsObj.categoryModel }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="数量：">
              {{ zulinProjectMsg.jobDetailsObj.categoryNum }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="计量单位：">
              {{ zulinProjectMsg.jobDetailsObj.unit }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="备注说明：">
              <span style="white-space: pre-wrap">{{zulinProjectMsg.jobDetailsObj.remarks}}</span>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!-- 审核记录 -->
    <div class="pdl10 pdr10" v-if="audit === 'view'">
      <h3>操作记录：</h3>
      <el-table
        :data="checkData"
        class="mt15"
        height="200px"
        highlight-current-row
        row-key="id"
        border
        ref="table"
      >
        <el-table-column
          type="index"
          label="序号"
          align="center"
          width="70"
        ></el-table-column>
        <el-table-column
          label="操作人"
          align="center"
          width="250"
          prop="createUserName"
        ></el-table-column>
        <el-table-column
          label="操作时间"
          align="center"
          width="250"
          prop="createDate"
        >
          <template slot-scope="scope">
            <span>{{
              scope.row.createDate ? scope.row.createDate.substring(0, 16) : ""
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作步骤"
          align="center"
          width="250"
          prop="currentSteps"
        ></el-table-column>
        <el-table-column label="结果" header-align="center" prop="content">
        </el-table-column>
      </el-table>
    </div>
    <div class="footer text-right">
      <el-button
        size="mini"
        icon="el-icon-edit-outline"
        v-if="audit === 'audit'"
        @click="auditSubmit"
        >审核
      </el-button>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import {
  getProjectMsgByIdForJuyi,
  getProjectAuditLog
} from "api/modules/projectManagement";
import VUE_CONFIG from "../../../../vue.config";
import { downloadFile } from "../../../utils/tools";

export default {
  props: {
    rowData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    audit: {
      type: String,
      default: ""
    }
  },
  filters: {
    dateFilter(time) {
      return bmTooljs.dateformat(new Date(time), "yyyy-MM-dd");
    }
  },
  computed: {
    ...mapState("dict", {
      projectDict: state => state.projectDict
    }),

    // 获取文件后缀名
    fileSuffixName() {
      const fileURL = this.zulinProjectMsg.contractTemplateUrl || "";
      return fileURL.substring(fileURL.lastIndexOf("."));
    },

    // 上传接口地址
    uploadUrl() {
      let uploadUrl = "";
      // 本地环境代理后无法直接获取路径
      if (process.env.VUE_APP_UPLOAD_URL == "/uploadApi") {
        uploadUrl = VUE_CONFIG.devServer.proxy["/uploadApi"].target;
      } else {
        uploadUrl = process.env.VUE_APP_UPLOAD_URL;
      }
      return uploadUrl;
    },

    //当前状态
    currentState() {
      const stateMap = {
        1: "待审核",
        2: "审核通过",
        3: "被驳回",
        default: "--"
      };
      return stateMap[this.zulinProjectMsg.isVerify] || stateMap["default"];
    }
  },
  data() {
    return {
      zulinProjectMsg: {
        id: "",
        baseId: "",
        businessId: "",
        sname: "",
        createDate: "", //发布时间
        projectProvinceName: "", //省
        projectCityName: "", //市
        linkPhone: "", //联系方式
        jobDetails: [], //求租产品详情
        jobDetailsObj: {}, //求租产品详情
        isVerify: null, // 当前状态
      },
      phone: "", // 联系方式
      isShow: true, // 控制显示icon
      checkData: [] //操作记录
    };
  },
  created() {
    if (!this.rowData.id) {
      this.$router.push({
        name: "to-audit-proJect-list"
      });
      return;
    }
    //数据加载
    this.getProjectMsgByIdForJuyi();
    if (this.audit === "view") {
      //操作记录
      this.getProjectAuditLog();
    }
  },
  methods: {
    // 下载文件
    doDownload() {
      downloadFile(
        this.uploadUrl + this.zulinProjectMsg.contractTemplateUrl,
        this.zulinProjectMsg.contractTemplateName + this.fileSuffixName
      );
    },

    // 查看文件
    doView() {
      const uploadUrl = process.env.VUE_APP_ZLT_UPLOAD_URL;
      window.open(
        this.$previewUrl + uploadUrl + this.zulinProjectMsg.contractTemplateUrl,
        "_blank"
      );
    },

    // 是否显示手机号
    isShowPhone() {
      this.isShow = !this.isShow;
      if (this.isShow) {
        this.phone = this.phone.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2");
      } else {
        this.phone = this.zulinProjectMsg.linkPhone;
      }
    },

    // 审核
    auditSubmit() {
      let params = {
        id: this.zulinProjectMsg.baseId
      };

      this.$emit("openDia", params);
    },
    //获取聚易厅项目
    getProjectMsgByIdForJuyi() {
      getProjectMsgByIdForJuyi({
        id: this.rowData.id
      }).then(res => {
        if (res.operationCode == "1") {
          this.zulinProjectMsg = res.data.project;
          this.phone = res.data.project.linkPhone.replace(
            /(\d{3})\d{4}(\d{4})/,
            "$1****$2"
          );
          this.zulinProjectMsg.sname = res.data.msgProject.sname;
          this.zulinProjectMsg.createDate = res.data.msgProject.createDate;
          this.zulinProjectMsg.isVerify = res.data.msgProject.isVerify;
          this.zulinProjectMsg.jobDetails = JSON.parse(
            res.data.project.rentSeekDetails
          );
          this.zulinProjectMsg.jobDetailsObj = this.zulinProjectMsg.jobDetails[0];
        }
      });
    },
    //查询审核记录
    getProjectAuditLog() {
      getProjectAuditLog({
        baseId: this.rowData.id
      }).then(res => {
        if (res.operationCode == "1") {
          this.checkData = res.data;
        }
      });
    }
  },
};
</script>
<style lang="less">
.juyi-project-msg-main {
  height: 100%;

  .expert-content {
    background-color: #fff;
    padding: 20px;
    position: relative;

    .img {
      position: absolute;
      top: 50px;
      right: 165px;
      width: 143px;
      height: 111px;
    }
  }
  .redtext {
    color: #ff0000;
  }

  .bluetext {
    color: #0000ff;
  }

  .footer {
    position: absolute;
    top: 88px;
    right: 135px;

    .el-button {
      height: 28px !important;
    }
  }
  .icon {
    width: 25px;
    margin-left: 10px;
    cursor: pointer;
  }
  .item .el-form-item__label {
    color: #2c3e50;
    font-weight: bolder;
  }
}
</style>
